import React, { forwardRef } from 'react';
import './ActionButtons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

const ActionButtons = forwardRef(function ActionButtons(props, ref) {
  const { mainAction, mainActionText, mainActionIcon, mainActionPreIcon, mainActionDisabled, cancel, cancelText, warningAction, warningActionText, currentStatus } = props;
  if (logComponent('ActionButtons')) { console.debug('ActionButtons rendered'); }

  return (
    <div className="Action-Buttons">
      <div className="Action-Buttons__spinner-container">
      { 
        currentStatus === 'pending' &&
        <FontAwesomeIcon icon="spinner" className="Action-Buttons__spinner" />
      }        
      </div>
      {
        mainAction && 
        <button 
          type="button"
          className="Action-Buttons__main-action"
          disabled={ mainActionDisabled }
          onClick={mainAction}
            ref={!warningAction && !cancel ? ref.current : null }>
          {mainActionPreIcon &&
            <FontAwesomeIcon className="Action-Buttons__pre-icon" icon={mainActionPreIcon} />
          }
          { mainActionText }  
          { mainActionIcon && 
            <FontAwesomeIcon className="Action-Buttons__icon" icon={mainActionIcon} />
          }
        </button>
      }
      {
        warningAction &&
        <button 
          type="button"
          className="Action-Buttons__warning-action"
          onClick={warningAction}
            ref={!cancel ? ref.current : null }>
          { warningActionText }
        </button>
        
      }
      {
        cancel && 
        <button 
          type="button"
          className="Action-Buttons__cancel"
          onClick={cancel}
            ref={ref.current}>
          { cancelText }
          
        </button>
      }
    </div>
  );
});
export default ActionButtons;